/** Matches Prisma `TimeEntryStatus`; sent as `timeEntryStatus` query param (comma-separated). */
export const BANDWIDTH_HOUR_STATUS_VALUES = ['APPROVED', 'PENDING', 'REJECTED'] as const;

export type BandwidthHourStatusValue = (typeof BANDWIDTH_HOUR_STATUS_VALUES)[number];

export const DEFAULT_BANDWIDTH_HOUR_STATUSES: BandwidthHourStatusValue[] = ['APPROVED', 'PENDING'];

export const BANDWIDTH_HOUR_STATUS_OPTIONS: { value: BandwidthHourStatusValue; label: string }[] = [
  { value: 'APPROVED', label: 'Approved' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'REJECTED', label: 'Rejected' },
];

const ORDER_INDEX: Record<BandwidthHourStatusValue, number> = {
  APPROVED: 0,
  PENDING: 1,
  REJECTED: 2,
};

export function formatBandwidthHourStatusChipValue(selected: string[]): string {
  const labelByValue = new Map(BANDWIDTH_HOUR_STATUS_OPTIONS.map((o) => [o.value, o.label]));
  return [...selected]
    .filter((v): v is BandwidthHourStatusValue =>
      BANDWIDTH_HOUR_STATUS_VALUES.includes(v as BandwidthHourStatusValue)
    )
    .sort((a, b) => ORDER_INDEX[a] - ORDER_INDEX[b])
    .map((v) => labelByValue.get(v) ?? v)
    .join(', ');
}
